import { memo } from 'react'

import { twMerge } from 'tailwind-merge'

import { IconCircle } from '~/components'

type Props = {
  onClick: () => void
  className?: string
}

const SearchThisAreaButtonComponent = ({ onClick, className }: Props) => {
  return (
    <button
      className={twMerge(
        'fixed flex h-[46px] w-[190px] items-center gap-2 rounded bg-white px-4 py-3 text-sm font-bold text-brand shadow-md transition-colors duration-200 hover:bg-gray-100 hover:shadow-lg',
        className,
      )}
      onClick={onClick}
    >
      <IconCircle className="h-6 w-6" />
      <span>このエリアで再検索</span>
    </button>
  )
}

export const SearchThisAreaButton = memo(SearchThisAreaButtonComponent)
